<script>
import { mapState } from 'vuex'
import { readableDate, readableFilesize } from '../../../helpers'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    level: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      formShow: true,
      // item: null,
      // selectedMedia: null,
      showMediaModal: false
    }
  },
  computed: {
    ...mapState('items', [
      'saving',
      'fetching',
      'modals'
    ]),
    ...mapState('modules', {
      module: 'current'
    }),
    ...mapState('config', {
      apiConfig: 'data'
    }),
    ...mapState('media', {
      mediaView: '_defaultView'
    }),
    mediaLibrary () {
      return this.modals.mediaLibrary
    },
    item () {
      return this.$store.getters['items/byID']({id: this.id})
    },
    selectedMedia () {
      if (this.item.media.length) {
        return this.item.media.filter((media) => {
          return media.id === this.item.media[0].id
        })[0]
      }

      return null
    },
    idsToHighlight () {
      if (this.selectedMedia) {
        return [this.selectedMedia.id]
      }
      return []
    },
    submitDisabled () {
      return this.fetching || this.saving || this.errors.any() || this.item.form.saving
    },
    url () {
      if (this.selectedMedia && this.selectedMedia.url) {
        return this.selectedMedia.url
      }
      else 
      {
        return ''
      }
    },
    name () {
      if (this.selectedMedia && this.selectedMedia.name) {
        return this.selectedMedia.name
      } else {
        return ''
      }
    }
  },
  watch: {
    formSuccess (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.errors.clear()
        this.formShow = false
        this.$nextTick(() => { this.formShow = true })
      }
    }
  },
  created: function(){
    //this.item = this.$store.getters['items/byID']({id: this.id})
  },
  methods: {
    readableFilesize,
    readableDate,
    setMediaID (media) {
      this.hideLibraryModal()
      this.$store.commit('items/setProps', {
        id: this.item.id,
        props: {
          media: [media]
        }
      })
    },
    showLibraryModal () {
      this.mediaLibraryVisible = true
      this.$store.commit('items/showMediaLibraryModal')
    },
    hideLibraryModal () {
      this.mediaLibraryVisible = false
      this.$store.commit('items/hideMediaLibraryModal')
    },
    displayMedia (show) {
      this.showMediaModal = show
    },
    onSubmit (event) {
      event.preventDefault()

      this.$store.commit('items/setFormSuccess', {
        id: this.item.id,
        value: false
      })

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('items/storeMedia', {
            id: this.item.id,
            data: this.item.form.fields
          })
        }
      })
    },
    setName (event) {
      this.$store.commit('items/setFormField', {
        id: this.item.id,
        field: 'name',
        value: event
      })
    },
    setFile (event) {
      let file
      if (event.target && event.target.files) {
        file = event.target.files[0]
      } else {
        file = event
      }

      let fileName = null
      let first = true
      if (this.item.form.fields.file) {
        fileName = this.item.form.fields.file.name
        first = false
      }

      this.$store.commit('items/setFormField', {
        id: this.item.id,
        field: 'file',
        value: file
      })

      const updatedFileName = this.item.form.fields.file.name
      const changed = fileName !== updatedFileName

      if (
        this.item.form.fields.name === '' ||
        this.item.form.fields.name === null ||
        !first && changed
      ) {
        this.$store.commit('items/setFormField', {
          id: this.item.id,
          field: 'name',
          value: updatedFileName.replace(/\.[^/.]+$/, '')
        })
      }
    },
    setThumbnail (event) {
      this.$store.commit('items/setFormField', {
        id: this.item.id,
        field: 'thumbnail',
        value: event.target.files[0]
      })
    }
    // setSelectedMedia () {
    //   if (this.item.media.length) {
    //     this.selectedMedia = this.item.media.filter((media) => {
    //       return media.id === this.item.media[0].id
    //     })[0]
    //   }

    //   return null
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/mixins/media-item.vue